/**
 * Convert a string into a URL-friendly slug.
 * @param {*} str The string to slugify
 * @param {*} options Options object
 * @param {boolean} options.removeDiacritics Whether to remove diacritics (e.g. accents). Default: false
 * @param {boolean} options.allowEdgeDashes Whether to allow dashes at the start or end of the slug. Default: false
 * @returns The slugified string
 */
export default function slugify(str, options = {}) {
	if (!str || typeof str !== 'string') return str;

	// Decompose characters into base + combining marks (e.g. é → e + ́), then strip the marks
	if (options.removeDiacritics) {
		str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	}

	str = str
		.replace(/'+/g, '') // Remove apostrophes (so "don't" → "dont" not "don-t")
		.replace(/[^a-z0-9]+/gi, '-') // Replace non-alphanumeric runs with a single dash
		.toLowerCase(); // Convert to lowercase

	// Strip leading/trailing dashes (unless allowEdgeDashes is set for typing UX)
	if (!options.allowEdgeDashes) {
		str = str.replace(/^-+|-+$/g, '');
	}

	return str;
}